import PropTypes from 'prop-types';
import React, { Component } from 'react';

import axios from 'axios';
import { camelizeRecursive } from '../utils/inflect';
import Domains from '../../../../constants/Domains';

const api = axios.create({
  transformResponse: data => camelizeRecursive(JSON.parse(data))
});

import { memoize } from 'lodash';

const API_URI = '/system/ajax_handlers/user_info.php';

import hui from 'hui';

const HoverMenu = hui.HoverMenu;
const LinkItem = hui.LinkItem;

const GA_CATEGORY = 'Header Menu';
const GA_LABEL = 'Header Menu - ';

const getUserInfo = () => api.get(API_URI);

export default class LoginBar extends Component {
  static propTypes = {
    // eslint-disable-line
    abTestTradieButton: PropTypes.string
  };

  state = {
    loggedIn: false,
    googleEventLabel: '',
    numberMessages: '',
    userThumbnail: '',
    userRole: '',
    messageCentreWebPath: '',
    inspirationBoardWebPath: ''
  };

  componentDidMount() {
    this.getUserData();
  }

  getUserData = () =>
    getUserInfo().then((response) => {
      this.setState({
        loggedIn: response.data.loggedIn,
        googleEventLabel: response.data.googleEventLabel,
        numberMessages: response.data.numberMessages,
        userThumbnail: response.data.userThumbnail,
        userRole: response.data.userRole,
        numLeads: response.data.numLeads,
        messageCentreWebPath: response.data.messageCentreWebPath,
        inspirationBoardWebPath: response.data.inspirationBoardWebPath
      });
    });

  render() {
    const {
      loggedIn,
      googleEventLabel,
      numberMessages,
      userThumbnail,
      userRole,
      numLeads,
      messageCentreWebPath,
      inspirationBoardWebPath
    } = this.state;
    const gaEventLabel = GA_LABEL + googleEventLabel;

    let { abTestTradieButton } = this.props;

    // ab test USER-1086 - if optimizely has set text for the tradie signup button
    if (typeof abTestTradieButton === 'undefined') {
      abTestTradieButton = 'List your business';
    }

    return (
      <div>
        {loggedIn === true && (
          <div>
            <a href={messageCentreWebPath} className="hui-header__messages">
              <span className="hui-header__unread-messages">{numberMessages || 0}</span>
            </a>
            <ul className="hui-header__hover-menu--user">
              <HoverMenu
                className={'hover-menu--user'}
                menuItem={
                  <img
                    className="hui-header__user-thumbnail"
                    alt="Your Avatar"
                    src={`//${Domains.AVATAR_SERVICE_URL}/creative/users/${userThumbnail}/140x140.jpg`}
                  />
                }
              >
                {userRole === 'advertiser' && (
                  <ul className="hover-menu__list">
                    <li>
                      <LinkItem
                        GACategory={GA_CATEGORY}
                        GAAction="Advertiser Centre"
                        GALabel={gaEventLabel}
                        href="/account"
                        title="Advertiser Centre"
                      >
                        Advertiser Centre
                      </LinkItem>
                    </li>
                    <li>
                      <LinkItem
                        GACategory={GA_CATEGORY}
                        GAAction="Manage Leads"
                        GALabel={gaEventLabel}
                        href="/account/leads"
                        title="Manage Leads"
                      >
                        Manage Leads
                        <span className="hover-menu__num-leads">{numLeads}</span>
                      </LinkItem>
                    </li>
                  </ul>
                )}
                <ul className="hover-menu__list">
                  <li>
                    <LinkItem
                      GACategory={GA_CATEGORY}
                      GAAction="Jobs"
                      GALabel={gaEventLabel}
                      href="/account/jobs"
                      title="Jobs"
                    >
                      Jobs
                    </LinkItem>
                  </li>
                  <li>
                    <LinkItem
                      GACategory={GA_CATEGORY}
                      GAAction="Find Friends"
                      GALabel={gaEventLabel}
                      href="/feed"
                      title="Find Friends"
                    >
                      Find Friends
                    </LinkItem>
                  </li>
                  <li>
                    <LinkItem
                      GACategory={GA_CATEGORY}
                      GAAction="Inspiration Boards"
                      label={GA_LABEL}
                      href={inspirationBoardWebPath}
                      title="Inspiration Boards"
                    >
                      Inspiration Boards
                    </LinkItem>
                  </li>
                  <li>
                    <LinkItem
                      GACategory={GA_CATEGORY}
                      GAAction="Contacts"
                      GALabel={gaEventLabel}
                      href="/account/contacts"
                      title="Contacts"
                    >
                      Contacts
                    </LinkItem>
                  </li>
                </ul>
                <ul className="hover-menu__list">
                  <li>
                    <LinkItem
                      GACategory={GA_CATEGORY}
                      GAAction="Edit Profile"
                      GALabel={gaEventLabel}
                      href="/account/edit"
                      title="Edit Profile"
                    >
                      Edit Profile
                    </LinkItem>
                  </li>
                  <li>
                    <LinkItem
                      GACategory={GA_CATEGORY}
                      GAAction="Change Password"
                      GALabel={gaEventLabel}
                      href="/account/change-password"
                      title="Change Password"
                    >
                      Change Password
                    </LinkItem>
                  </li>
                  <li>
                    <LinkItem
                      GACategory={GA_CATEGORY}
                      GAAction="Unsubscribe"
                      GALabel={gaEventLabel}
                      href="/account/subscribe"
                      title="Unsubscribe"
                    >
                      Unsubscribe
                    </LinkItem>
                  </li>
                </ul>
                <ul className="hover-menu__list">
                  <li>
                    <LinkItem
                      GACategory={GA_CATEGORY}
                      GAAction="Logout"
                      GALabel={gaEventLabel}
                      href="/account/?m=public&a=logout"
                      title="Log out"
                    >
                      Logout
                    </LinkItem>
                  </li>
                </ul>
              </HoverMenu>
            </ul>
          </div>
        )}
        {loggedIn === false && (
          <ul className="hui-header__link-list--logout">
            <li className="hui-header__link">
              <LinkItem GACategory={GA_CATEGORY} GAAction="Sign Up" GALabel={gaEventLabel} href="/register" title="Register">
                Register
              </LinkItem>
            </li>
            <li className="hui-header__link">
              <LinkItem GACategory={GA_CATEGORY} GAAction="Login" GALabel={gaEventLabel} href="/login" title="Sign in">
                Sign In
              </LinkItem>
            </li>
            <li className="hui-header__link">
              <LinkItem
                GACategory={GA_CATEGORY}
                GAAction="List Your Business"
                GALabel={gaEventLabel}
                href="/advertise"
                title={abTestTradieButton}
                className="hui-header__btn"
              >
                {abTestTradieButton}
              </LinkItem>
            </li>
          </ul>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./header/scripts/components/login-bar.js